import { uiText, useUiLanguage } from '@/i18n/interface';
import React from 'react';
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import PaymentMethodsManager from './PaymentMethodsManager';

interface PaymentSettingsDialogProps {
  isOpen: boolean;
  onOpenChange: (open: boolean) => void;
}

const PaymentSettingsDialog: React.FC<PaymentSettingsDialogProps> = ({
  isOpen,
  onOpenChange
}) => {
  useUiLanguage();
  return (
    <Dialog open={isOpen} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-6xl max-h-[95vh] overflow-y-auto p-3 sm:p-6">
        <DialogHeader className="space-y-2">
          <DialogTitle className="text-lg sm:text-xl">{uiText("Payment Methods")}</DialogTitle>
          <DialogDescription className="text-sm">
            {uiText("Configure payment methods for your dojo")}</DialogDescription>
        </DialogHeader>

        <div className="space-y-2 sm:space-y-4 mt-4">
          <PaymentMethodsManager />
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default PaymentSettingsDialog;